import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { UserService } from '@wm-libs/core';
import { Observable } from 'rxjs';
import { CanActivateChild, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivateChild {
  constructor(private userService: UserService, private router: Router) {}

  canActivateChild(): Observable<boolean> {
    return this.userService.isAuthenticated$.pipe(
      map((isAuthenticated) => {
        if (!isAuthenticated) {
          window.location.href = environment.techDomain;
        }

        return isAuthenticated;
      })
    );
  }

  canActivate(): Observable<boolean> {
    return this.userService.isAuthenticated$.pipe(
      map((isAuthenticated) => {
        if (!isAuthenticated) {
          window.location.href = environment.techDomain;
        }

        return isAuthenticated;
      })
    );
  }
}
